import { HealthcareProviderType } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { assertUnreachable, PromiseVoidFunction, TranslatableText } from '@dreryk/react-common';
import { Header, Panel } from '@dreryk/react-components';

import { healthcareOrganizationTranslationKeys, healthcarePracticeTranslationKeys } from '../translations';

import { HealthcareProviderNavTabs } from './HealthcareProviderNavTabs';

const resolveHealthcareProviderHeaderKey = (healthcareProviderType: HealthcareProviderType): TranslatableText => {
   switch (healthcareProviderType) {
      case 'HEALTHCARE_PRACTICE':
         return healthcarePracticeTranslationKeys.myPractice;
      case 'HEALTHCARE_ORGANIZATION':
         return healthcareOrganizationTranslationKeys.myOrganization;
      default:
         return assertUnreachable(healthcareProviderType);
   }
};

type HealthcareProviderPanelProps = {
   readonly healthcareProviderType: HealthcareProviderType;
   readonly verifyAccountConfiguration: PromiseVoidFunction;
};

export const HealthcareProviderPanel = (props: HealthcareProviderPanelProps): JSX.Element => {
   const headerKey = resolveHealthcareProviderHeaderKey(props.healthcareProviderType);

   return (
      <Panel testId={'healthcareProvider'} direction='column' overflow={'auto'}>
         <Header testId={'healthcareProvider'}>{headerKey}</Header>
         <HealthcareProviderNavTabs
            healthcareProviderType={props.healthcareProviderType}
            verifyAccountConfiguration={props.verifyAccountConfiguration}
         />
      </Panel>
   );
};
